import $ from 'jquery';
import 'selectize';
import initSelectize from "../../helper_functions/initSelectize";

initSelectize()

$('.boeckmann-trade-fairs-selectbox').on('change', function(){
    $('.boeckmann-trade-fairs-form').submit();
})